import * as angular from "angular";
import template from "./view-mode-fallback.html";
import type {
	MaybeAsync,
	ViewModeOperationResult
} from "./view-modes-section-types";
import type { ViewModesSectionController } from "./view-modes-section";

export interface ViewModeFallbackController {
	active?: boolean;
	loading?: boolean;
	message?: string;
	retryLabel?: string;
	onRetry?: () => MaybeAsync<ViewModeOperationResult>;
	section: ViewModesSectionController;
}

// AngularJS owns these merged binding properties; keeping them type-only preserves pre-assigned values.
// eslint-disable-next-line no-redeclare
export class ViewModeFallbackController {
	public $onInit(): void {
		this.section.registerFallback(this);
	}

	public canRetry(): boolean {
		return !!this.onRetry && this.loading !== true;
	}

	public async retry(): Promise<boolean> {
		if(!this.canRetry()) {
			return false;
		}

		try {
			return await this.onRetry?.() !== false;
		}
		catch{
			return false;
		}
	}
}

export default angular
	.module("vesl.components.view-modes-section.fallback", [])
	.component("viewModeFallback", {
		template,
		controller: ViewModeFallbackController,
		bindings: {
			active: "<?isActive",
			loading: "<?isLoading",
			message: "@?",
			retryLabel: "@?",
			onRetry: "&?"
		},
		require: {
			section: "^^viewModesSection"
		}
	})
	.name;
